import { BLOCK_TYPES } from "../../common/index";
const { LONG_ANSWER_BLOCK } = BLOCK_TYPES;

const LONG_ANSWER_DEFAULT_VALUE = {
    type: LONG_ANSWER_BLOCK,
    data: {
        [LONG_ANSWER_BLOCK]: {
            text: [],
            solution: [],
            limit: 1000,
            hasLimit: false,
            description: [],
            isRequired: false,
        },
        jumpTo: {
            default: null,
            conditions: [],
        },
    },
};

export default LONG_ANSWER_DEFAULT_VALUE;
